import { Button } from "@mui/material";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import React from "react";
import axios from "axios";
import { ImgContext } from "../Context/ImageCon";
function Texts() {
  const [text, setText] = React.useState("");
  // eslint-disable-next-line no-unused-vars
  const [img, setImg] = React.useContext(ImgContext);
  //   console.log(text);

  //   React.useEffect(() => {});
  let handleClick = () => {
    axios
      .post("qrcode/", { name: text })
      .then((res) => {
        console.log(res.data.img);
        setImg(res.data.img);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="section">
      <TextareaAutosize
        aria-label="empty textarea"
        className="textarea"
        style={{ overflow: "scroll" }}
        placeholder="Click here to enter text"
        onChange={(e) => setText(e.target.value)}
      />
      <Button
        onClick={handleClick}
        style={{ marginTop: "12%" }}
        variant="contained"
        color="primary"
      >
        Make QR
      </Button>
    </div>
  );
}

export default Texts;
